/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface LeadList
 */
export interface LeadList {
  /**
   *
   * @type {Array<any>}
   * @memberof LeadList
   */
  audienceIds?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadList
   */
  audienceKeys?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof LeadList
   */
  companyId: number;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadList
   */
  csvColumns?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadList
   */
  csvIds?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadList
   */
  csvKeys?: Array<any>;
  /**
   *
   * @type {number}
   * @memberof LeadList
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof LeadList
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  listId?: string;
  /**
   *
   * @type {string}
   * @memberof LeadList
   */
  name?: string;
}

/**
 * Check if a given object implements the LeadList interface.
 */
export function instanceOfLeadList(value: object): value is LeadList {
  if (!('companyId' in value) || value['companyId'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function LeadListFromJSON(json: any): LeadList {
  return LeadListFromJSONTyped(json, false);
}

export function LeadListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadList {
  if (json == null) {
    return json;
  }
  return {
    audienceIds:
      json['audience_ids'] == null ? undefined : json['audience_ids'],
    audienceKeys:
      json['audience_keys'] == null ? undefined : json['audience_keys'],
    companyId: json['company_id'],
    csvColumns: json['csv_columns'] == null ? undefined : json['csv_columns'],
    csvIds: json['csv_ids'] == null ? undefined : json['csv_ids'],
    csvKeys: json['csv_keys'] == null ? undefined : json['csv_keys'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    id: json['id'],
    key: json['key'],
    listId: json['list_id'] == null ? undefined : json['list_id'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function LeadListToJSON(value?: LeadList | null): any {
  if (value == null) {
    return value;
  }
  return {
    audience_ids: value['audienceIds'],
    audience_keys: value['audienceKeys'],
    company_id: value['companyId'],
    csv_columns: value['csvColumns'],
    csv_ids: value['csvIds'],
    csv_keys: value['csvKeys'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    id: value['id'],
    key: value['key'],
    list_id: value['listId'],
    name: value['name'],
  };
}
